import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarApple from './NavbarApple';
import SidebarApple from './SidebarApple';
import FooterApple from './FooterApple';
import { useTheme } from '../../contexts/ThemeContext';

// Try to import PlanContext, but fallback gracefully if not available
let usePlan;
try {
  const PlanContext = require('../../contexts/PlanContext');
  usePlan = PlanContext.usePlan;
} catch (e) {
  usePlan = () => ({ user: null, planInfo: null, logout: () => {} });
}

const MainLayoutApple = ({ 
  children, 
  user: userProp, 
  planInfo: planInfoProp, 
  onLogout: onLogoutProp,
  showSidebar = true,
  showFooter = true,
  footerVariant = 'dashboard'
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isDarkMode } = useTheme(); // Subscribe to theme changes to trigger re-render
  const navigate = useNavigate();
  
  // Use PlanContext for reactive updates, fall back to props for backward compatibility
  const { user: contextUser, planInfo: contextPlanInfo, logout: contextLogout } = usePlan();
  const user = contextUser || userProp;
  const planInfo = contextPlanInfo || planInfoProp;
  
  // FIX 2: Close mobile menu on resize to desktop
  useEffect(() => {
    const handleResize = () => {
      // Close mobile menu when viewport reaches desktop breakpoint (1024px)
      if (window.innerWidth >= 1024 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileMenuOpen]);
  
  const handleLogout = () => {
    if (onLogoutProp) {
      onLogoutProp();
    } else {
      contextLogout();
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="apple-ui-root" data-theme={isDarkMode ? 'dark' : 'light'}>
      <NavbarApple 
        user={user} 
        planInfo={planInfo} 
        onLogout={handleLogout}
        onToggleSidebar={toggleMobileMenu}
        isDarkMode={isDarkMode}
      />
      
      {showSidebar && (
        <SidebarApple 
          collapsed={sidebarCollapsed}
          onToggle={toggleSidebar}
          isMobileOpen={mobileMenuOpen}
          onCloseMobile={closeMobileMenu}
        />
      )}
      
      <main 
        className={`apple-main ${!showSidebar ? 'no-sidebar' : ''} ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}
      >
        <div className="apple-main-content">
          {children}
        </div>
        
        {showFooter && (
          <FooterApple variant={footerVariant} />
        )}
      </main>
    </div>
  );
};

export default MainLayoutApple;
